module.exports = __webpack_public_path__ + "static/media/news-benita-zahn-hosts-mental-health-panel-discussion.b3ce58a8.jpg";